export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./modal-link.vue?vue&type=template&id=89361ac0"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/modal-link/africa/modal-link.vue?vue&type=template&id=89361ac0
// module id = /8Of
// module chunks = 37